export var Type = /*#__PURE__*/ function(Type) {
    Type["Array"] = "Array";
    Type["Boolean"] = "Boolean";
    Type["ConceptUuid"] = "ConceptUuid";
    Type["Number"] = "Number";
    Type["Object"] = "Object";
    Type["String"] = "String";
    Type["UUID"] = "UUID";
    Type["PersonAttributeTypeUuid"] = "PersonAttributeTypeUuid";
    Type["PatientIdentifierTypeUuid"] = "PatientIdentifierTypeUuid";
    return Type;
}({});
